import { ThemeConfig } from 'antd';

/**
 * Ant Design theme configuration for PePoll Platform
 * Customizes colors, typography, and component styles
 */
export const pepollTheme: ThemeConfig = {
  token: {
    // Cores da marca PePoll — extraídas da logomarca
    colorPrimary: '#2E2B81', // Indigo escuro (texto "PePoll" do logo)
    colorSuccess: '#00984A', // Verde (ícone de gráfico do logo)
    colorWarning: '#FFC200', // Amarelo (barra do logo)
    colorError: '#ff4d4f',
    colorInfo: '#2E2B81',

    // Typography
    fontSize: 14,
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",

    // Border radius
    borderRadius: 6,

    // Layout
    colorBgLayout: '#f7f8fa',

    // Links
    colorLink: '#2E2B81',
    colorLinkHover: '#4540b5',
    colorLinkActive: '#1e1b6e',
  },
  components: {
    Layout: {
      headerBg: '#ffffff',
      headerColor: '#2E2B81',
      headerHeight: 64,
    },
    Menu: {
      darkItemBg: '#2E2B81',
      darkItemColor: 'rgba(255, 255, 255, 0.65)',
      darkItemSelectedBg: '#4540b5',
      darkItemSelectedColor: '#ffffff',
    },
    Form: {
      labelFontSize: 14,
      itemMarginBottom: 24,
    },
    Button: {
      controlHeight: 40,
      fontSize: 14,
      fontWeight: 500,
    },
    Input: {
      controlHeight: 40,
    },
    Select: {
      controlHeight: 40,
    },
    DatePicker: {
      controlHeight: 40,
    },
    Card: {
      borderRadius: 8,
      boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.03), 0 1px 6px -1px rgba(0, 0, 0, 0.02), 0 2px 4px 0 rgba(0, 0, 0, 0.02)',
    },
    Table: {
      headerBg: '#fafafa',
      headerColor: '#000000d9',
    },
  },
};
